import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { footerConfigs } from '~/company/configs/footerConfig';

import Icon from '../Icon/Icon';

import styles from './LayoutLocalee.module.scss';
import { PaymentMethodsList } from './PaymentMethodsList';
export const LayoutLocalee = observer(() => {
  const { t } = useTranslation();
  const footerConfig = footerConfigs[company.name] || footerConfigs.default;

  if (!footerConfig) {
    return null;
  }

  return (
    <footer className={styles.footer} data-company={company.name}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.colHotline}>
            <div className={styles.colTitle}>{t('hotline')}</div>
            <div className={styles.phone}>{company.config.phoneNumber}</div>
            <a
              href={company.config.links.whatsapp}
              target="_blank"
              rel="noreferrer"
              className={styles.messageBtn}
            >
              <Icon type="whatsapp" size={16} /> {t('sendMessage')}
            </a>
          </div>

          {footerConfig.sections.map((section) => (
            <div key={section.title} className={styles.col}>
              <div className={styles.colTitle}>{t(section.title)}</div>
              {section.items.map((item) => (
                <Link key={item.link} to={item.link} data-link={item.dataLink}>
                  {t(item.title)}
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className={styles.paymentMethods}>
          <PaymentMethodsList classNames={styles.paymentMethodsList} />
          <div className={styles.downloadApp}>
            <img
              className={styles.qrCode}
              src={company.images.qr.maxi}
              alt="QR Code to download app"
            />
            <div className={styles.downloadInfo}>
              <p>{t('downloadAppFooter')}</p>
              <div className={styles.storeButtons}>
                {company.config.appStoreUrl.android && (
                  <a
                    href={company.config.appStoreUrl.android}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon type="gplay" size={20} />
                    <div className={styles.buttonText}>
                      <span className={styles.action}>{t('getOn')}</span>
                      <span className={styles.store}>Google Play</span>
                    </div>
                  </a>
                )}
                {company.config.appStoreUrl.ios && (
                  <a
                    href={company.config.appStoreUrl.ios}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon type="apple" size={20} />
                    <div className={styles.buttonText}>
                      <span className={styles.action}>{t('downloadOn')}</span>
                      <span className={styles.store}>App Store</span>
                    </div>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bottomSection}>
          <div className={styles.logo}>
            <img src={company.images.logo.light} alt="logo" />
            <span>
              © 2025 {company.config.officialName} All rights reserved.
            </span>
          </div>
          <div className={styles.socials}>
            {company.config.links.linkedin && (
              <a
                href={company.config.links.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                <Icon type="linkedin" size={20} />
              </a>
            )}
            {company.config.links.instagram && (
              <a
                href={company.config.links.instagram}
                target="_blank"
                rel="noreferrer"
              >
                <Icon type="insta" size={20} />
              </a>
            )}
            {company.config.links.facebook && (
              <a
                href={company.config.links.facebook}
                target="_blank"
                rel="noreferrer"
              >
                <Icon type="fb" size={20} />
              </a>
            )}
            {company.config.links.tiktok && (
              <a
                href={company.config.links.tiktok}
                target="_blank"
                rel="noreferrer"
              >
                <Icon type="tiktok" size={20} />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
});
